import React, { Component } from 'react';
import { View, Text } from 'react-native';
import Icon from '../../../Icon';
import utils from '../utils';
import { enabledStyle, disabledStyle } from '../commonStyles';

const statusMap: { [propName: string]: string } = {
    10: 'isWarning',
    11: 'isWarning'
};

const appActionMap: { [propName: string]: boolean } = {
    pay: true
};

class Scenerycar extends Component<{
    data: { scenerycarList: []; agentName: string; _disable: boolean };
}> {
    public static formatData = (data: any) => {
        const newData = { ...data };
        // icon
        newData.iconfont = '\uf281';
        newData.iconColor = '#00c2f1';
        // 状态
        newData._orderStatus = statusMap[newData.status];
        // 按钮
        newData.actionInfos = utils.buildActionInfos(newData.appAction, appActionMap);
        // 价格
        newData.currency = (newData.currency || '').trim();
        newData.fixPrice = utils.fixPrice(newData.price, newData.currency);
        newData.fixConvertPrice = utils.fixPrice(newData.convertPrice);
        if (newData.scenerycarList) {
            newData.scenerycarList = newData.scenerycarList.map(
                (scenerycar: { fromDate: string }) => ({
                    ...scenerycar,
                    fixFromDate: utils.buildDateTime(scenerycar.fromDate)
                })
            );
        }

        return newData;
    };

    public render() {
        const { data: { scenerycarList = [], agentName, _disable } = {} } = this.props;
        const styles = _disable ? disabledStyle : enabledStyle;

        return (
            <View style={styles.left}>
                {scenerycarList.map((carItem, index) => (
                    <View
                        style={[
                            styles.rowWithIcon,
                            index === scenerycarList.length - 1
                                ? null
                                : styles.ticketItemWithSiblings
                        ]}
                        key={index}
                    >
                        {Boolean(carItem.isStart) && (
                            <View style={styles.textIconWrapper}>
                                <Text style={[styles.textIcon, { color: '#fff' }]}>去</Text>
                            </View>
                        )}
                        {Boolean(carItem.isReturn) && (
                            <View style={[styles.textIconWrapper, styles.back]}>
                                <Text style={[styles.textIcon, { color: '#fff' }]}>返</Text>
                            </View>
                        )}
                        <Text
                            numberOfLines={1}
                            style={[
                                styles.newOrderSubTitle,
                                carItem.isStart || carItem.isReturn ? styles.ml22 : null
                            ]}
                        >
                            <Text>{carItem.fromStation}</Text>
                            <Icon code="&#xe69c;" />
                            <Text>{carItem.toStation}</Text>
                        </Text>

                        {Boolean(carItem.fixFromDate) && (
                            <Text
                                numberOfLines={1}
                                style={[
                                    styles.newOrderSubTitle,
                                    carItem.isStart || carItem.isReturn ? styles.ml22 : null
                                ]}
                            >
                                {`${carItem.fixFromDate} 发车`}
                            </Text>
                        )}
                    </View>
                ))}
                {Boolean(agentName) && (
                    <Text numberOfLines={1} style={styles.newOrderSubTitle}>
                        {`代理商  ${agentName}`}
                    </Text>
                )}
            </View>
        );
    }
}

export default Scenerycar;
